module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    staticClass: "stage-pic",
    style: ({
      'background-image': 'url(' + _vm.imageSrc + ')'
    })
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-dot"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-asterisk"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-lang"
  }, [_vm._v(_vm._s(_vm.languageSay))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2acb318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PictureNaming.vue
// module id = 170
// module chunks = 1